function isFunction(str){
	return typeof str === 'function';
}

function getTimezoneDateTime(timestamp, timezone) {
	var d = new Date(timestamp);
	if (!timezone) return d;

	var datetime = new Date(d.getTime() + d.getTimezoneOffset() * 60000); // to UTC
		datetime.setHours(datetime.getHours() + timezone); // to Timezone

	return datetime;
}

function pading(num) {
	let norm = Math.floor(Math.abs(num));
	return (norm < 10 ? '0' : '') + norm;
}

function formatDateTime(timestamp, timezone) {
	var date = utils.getTimezoneDateTime(timestamp, timezone);
	var year = date.getFullYear();
	var dd = pading(date.getDate());
	var mm = pading(date.getMonth() + 1);
	var h = pading(date.getHours());
	var m = pading(date.getMinutes());
	var tzOffset = -date.getTimezoneOffset();
	var difference = tzOffset >= 0 ? '+' : '-';
	var hoursTzOffset = pading(tzOffset / 60);
	var minutesTzOffset = pading(tzOffset % 60);

	return `${dd}.${mm}.${year} ${h}:${m} (${difference}${hoursTzOffset}:${minutesTzOffset})`;
}

function formatTime(sec) {
	var timeHour = Math.floor(sec / 3600);
	var timeMinute = Math.floor(sec % 3600 / 60);
	var timeSecond = Math.floor(sec % 60);
	var timeDay = Math.floor(timeHour / 24);

	if (timeDay != 0) timeHour = timeHour % 24;
	if (timeHour == 0) timeHour = "00";
	else if (timeHour < 10) timeHour = "0" + timeHour;
	if (timeMinute == 0) timeMinute = "00";
	else if (timeMinute < 10) timeMinute = "0" + timeMinute;
	if (timeSecond == 0) timeSecond = "00";
	else if (timeSecond < 10) timeSecond = "0" + timeSecond;

	var timeRemain = `${timeHour}:${timeMinute}:${timeSecond}`;
	if (timeDay != 0) {
		var remainder = timeDay % 10;
		var remainderHundred = timeDay % 100;
		var wordDay = '';
		if ((remainderHundred >= 11 && remainderHundred <= 14)) {
			wordDay = this.localize('Days');
		} else if (remainder >= 2 && remainder <= 4) {
			wordDay = this.localize('Sdays');
		} else if (remainder == 1) {
			wordDay = this.localize('Day');
		} else {
			wordDay = this.localize('Days');
		}

		timeRemain = `${timeDay} ${wordDay} ${timeRemain}`;
	}

	return timeRemain;
}

var utils = {
	isFunction: isFunction,
	formatDateTime: formatDateTime,
	formatTime: formatTime,
	getTimezoneDateTime: getTimezoneDateTime
};

export default utils;